import { c as _c } from "react/compiler-runtime";
import { ApiWaveLog } from "@/generated/models/ApiWaveLog";
import { formatNumberWithCommas, getTimeAgoShort } from "@/helpers/Helpers";
import Link from "next/link";
import { WaveLeaderboardRightSidebarActivityLogDrop } from "./WaveLeaderboardRightSidebarActivityLogDrop";
import { ApiWaveCreditType } from "@/generated/models/ApiWaveCreditType";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { SystemAdjustmentPill } from "@/components/common/SystemAdjustmentPill";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
interface WaveLeaderboardRightSidebarActivityLogProps {
  readonly log: ApiWaveLog;
  readonly creditType: ApiWaveCreditType;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const WaveLeaderboardRightSidebarActivityLog: React.FC<WaveLeaderboardRightSidebarActivityLogProps> = t0 => {
  const $ = _c(52);
  const {
    log,
    creditType,
    onDropClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <svg className="tw-w-3.5 tw-h-3.5 tw-text-iron-400 tw-flex-shrink-0" viewBox="0 0 24 24" aria-hidden="true" fill="none"><path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== log.created_at) {
    t2 = getTimeAgoShort(new Date(log.created_at).getTime());
    $[1] = log.created_at;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="tw-flex tw-items-center tw-gap-1.5">{t1}<span className="tw-text-xs tw-font-medium tw-text-iron-400">{t2}</span></div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== log || $[6] !== onDropClick) {
    t4 = <WaveLeaderboardRightSidebarActivityLogDrop log={log} onDropClick={onDropClick} />;
    $[5] = log;
    $[6] = onDropClick;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="tw-flex tw-items-center tw-justify-between">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = `/${log.invoker.handle}`;
  const t7 = `Voter: ${log.invoker.handle}`;
  let t8;
  if ($[11] !== log.invoker.pfp) {
    t8 = log.invoker.pfp ? <img src={log.invoker.pfp} alt="" className="tw-size-5 tw-rounded-md tw-ring-1 tw-ring-white/10 tw-bg-iron-800" /> : <div className="tw-size-5 tw-rounded-md tw-ring-1 tw-ring-white/10 tw-bg-iron-800" />;
    $[11] = log.invoker.pfp;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = log.invoker.handle ?? log.invoker.id;
  let t10;
  if ($[13] !== log.invoker.handle) {
    t10 = <span className="tw-text-sm tw-font-medium tw-text-iron-50 tw-transition-all tw-duration-300 desktop-hover:group-hover:tw-text-iron-300">{log.invoker.handle}</span>;
    $[13] = log.invoker.handle;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t9) {
    t11 = <UserProfileTooltipWrapper user={t9}>{t10}</UserProfileTooltipWrapper>;
    $[15] = t10;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8) {
    t12 = <Link href={t6} className="tw-flex tw-items-center tw-gap-2 tw-no-underline tw-group desktop-hover:hover:tw-opacity-80 tw-transition-all tw-duration-300" title={t7}>{t8}{t11}</Link>;
    $[18] = t11;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== log.contents.oldVote) {
    t13 = log.contents.oldVote === 0 ? <span className="tw-text-sm tw-text-iron-400">voted</span> : <span className="tw-text-sm tw-text-iron-500 tw-whitespace-nowrap">{formatNumberWithCommas(log.contents.oldVote)} →</span>;
    $[23] = log.contents.oldVote;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const t14 = `tw-text-sm tw-font-semibold tw-whitespace-nowrap ${log.contents.newVote > 0 ? "tw-text-green" : "tw-text-red"}`;
  let t15;
  if ($[25] !== log.contents.newVote) {
    t15 = formatNumberWithCommas(log.contents.newVote);
    $[25] = log.contents.newVote;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== creditType || $[28] !== t14 || $[29] !== t15) {
    t16 = <span className={t14}>{t15} {creditType}</span>;
    $[27] = creditType;
    $[28] = t14;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== log.contents.reason) {
    t17 = log.contents?.reason === "CREDIT_OVERSPENT" && <SystemAdjustmentPill />;
    $[31] = log.contents.reason;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t13 || $[34] !== t16 || $[35] !== t17) {
    t18 = <div className="tw-flex tw-items-center tw-gap-x-1.5 tw-min-w-0 tw-overflow-hidden">{t13}{t16}{t17}</div>;
    $[33] = t13;
    $[34] = t16;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  const t19 = `/${log.drop_author?.handle}`;
  const t20 = `Drop creator: ${log.drop_author?.handle}`;
  let t21;
  let t22;
  if ($[37] !== log.drop_author) {
    t21 = log.drop_author?.pfp ? <img src={log.drop_author.pfp} alt="" className="tw-size-5 tw-rounded-md tw-ring-1 tw-ring-white/10 tw-bg-iron-800 tw-flex-shrink-0" /> : <div className="tw-size-5 tw-rounded-md tw-ring-1 tw-ring-white/10 tw-bg-iron-800 tw-flex-shrink-0" />;
    t22 = log.drop_author?.handle ? <UserProfileTooltipWrapper user={log.drop_author.handle ?? log.drop_author.id}><span className="tw-text-sm tw-font-medium tw-text-iron-50 tw-transition-all tw-duration-300 desktop-hover:group-hover:tw-text-iron-300">{log.drop_author.handle}</span></UserProfileTooltipWrapper> : <span className="tw-text-sm tw-font-medium tw-text-iron-50 tw-transition-all tw-duration-300 desktop-hover:group-hover:tw-text-iron-300">{log.drop_author?.handle}</span>;
    $[37] = log.drop_author;
    $[38] = t21;
    $[39] = t22;
  } else {
    t21 = $[38];
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t19 || $[41] !== t20 || $[42] !== t21 || $[43] !== t22) {
    t23 = <Link href={t19} className="tw-flex tw-items-center tw-gap-2 tw-no-underline tw-group desktop-hover:hover:tw-opacity-80 tw-transition-all tw-duration-300" title={t20}>{t21}{t22}</Link>;
    $[40] = t19;
    $[41] = t20;
    $[42] = t21;
    $[43] = t22;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== t12 || $[46] !== t18 || $[47] !== t23) {
    t24 = <div className="tw-mt-1.5 tw-flex tw-items-center tw-flex-wrap tw-gap-2">{t12}{t18}{t23}</div>;
    $[45] = t12;
    $[46] = t18;
    $[47] = t23;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== t24 || $[50] !== t5) {
    t25 = <div className="tw-relative"><div className="tw-p-3 tw-rounded-lg tw-bg-iron-900">{t5}{t24}</div></div>;
    $[49] = t24;
    $[50] = t5;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  return t25;
};